<template>
  <div class="modal is-active components-order-offer-meal-modal__modal" v-if="visible">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">

      <header class="modal-card-head">
        <p class="modal-card-title has-text-centered has-text-weight-bold is-size-6-mobile">
          <span class="components-order-offer-meal-modal__title">
            <span v-if="amount > 0" class="has-text-success">{{ amount }}x</span>
            {{ offerMeal.name }}
          </span>
        </p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>

      <section class="modal-card-body p-3">

          <div class="components-order-offer-meal-modal__image" v-if="offerMeal.image_thumbnail">
            <img :src="offerMeal.image_thumbnail" :alt="offerMeal.name"/>
          </div>

          <div class="p-2">
            <p class="is-size-5 mb-0 has-text-weight-bold">
              <span v-if="amount > 0" class="has-text-success">{{ amount }}x</span>
              {{ offerMeal.name }}
            </p>
            <div class="is-flex is-flex-direction-row is-width-100 is-justify-content-space-between is-align-items-center">
              <p class="is-size-6 mt-1 mb-0" v-if="offerMeal.portion">
                {{ offerMeal.portion }}
              </p>
              <p class="is-size-5 mt-1 mb-0 has-text-right" v-if="offerMeal.price">
                {{ offerMeal.price_formatted }}
              </p>
            </div>
            <p v-if="offerMeal.description" class="has-text-grey mt-1 mb-0">
              {{ offerMeal.description }}
            </p>

            <div v-for="ingredientGroup in offerMeal.ingredient_groups" :key="ingredientGroup.id">
              <p class="is-size-5 mt-3">
                {{ ingredientGroup.question }}
              </p>
              <p class="is-size-7 mt-1 mb-3" :class="{'has-text-danger': hasError(ingredientGroup)}">
                <template v-if="ingredientGroup.min >= 1 && ingredientGroup.max >= 1">
                  Vyberte alespoň {{ ingredientGroup.min }} a maximálně {{ ingredientGroup.max }}
                </template>
                <template v-else-if="ingredientGroup.min >= 1">
                  Vyberte alespoň {{ ingredientGroup.min }}
                </template>
                <template v-else-if="ingredientGroup.max >= 1">
                  Vyberte maximálně {{ ingredientGroup.max }}
                </template>
              </p>
              <div v-for="ingredient in ingredientGroup.ingredients" :key="ingredient.id">
                <div class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center mt-1">
                  <div class="components-order-offer-meal-modal__checkbox">
                    <b-checkbox
                        :value="checkedIngredient(ingredientGroup, ingredient)"
                        @input="toggleIngredient(ingredientGroup, ingredient, ...arguments)"
                        type="is-success"
                    >
                      {{ ingredient.name }}
                    </b-checkbox>
                  </div>
                  <p v-if="ingredient.price > 0">+{{ ingredient.price_formatted }}</p>
                </div>
              </div>
            </div>
          </div>

      </section>

      <footer class="modal-card-foot has-background-white-bis">
          <div class="level is-width-100">

                <span class="level-item is-flex-grow-0" v-if="offerMeal.price > 0">
                  <span class="has-text-weight-bold is-size-5" :class="{
                    'has-text-success': !!cartLine,
                    'has-text-black': !cartLine
                  }">{{ price }}</span>
                  <span
                      v-if="offerMeal.packaging_price"
                      class="tooltip is-tooltip-top mx-3"
                      :class="{'has-text-success': !!cartLine, 'has-text-grey-light': !cartLine }"
                      :data-tooltip="'+ ' + packagingPrice"
                  >
                    <span class="icon icon--2"><i class="fas fa-box-open"></i></span>
                  </span>
                </span>

                <div class="level-item is-flex is-flex-direction-row is-justify-content-space-between">

                  <div class="is-flex is-flex-direction-row is-align-items-center">

                    <button class="button is-white is-small ml-3 px-5 py-4" @click="removeAmount">
                      <span class="icon icon--cart"><i class="fas fa-minus"></i></span>
                    </button>

                    <span class="px-3 mr-1 has-text-weight-bold" :class="{'has-text-success': amount > 0}">{{ amount }}x</span>

                    <button class="button is-success is-light is-small px-5 py-4" @click="addAmount">
                      <span class="icon icon--cart"><i class="fas fa-plus"></i></span>
                    </button>

                  </div>

                  <div>
                    <span @click.capture="errorScroll">
                      <button
                          v-if="!soldOut && offerMeal.price > 0 && amount > 0"
                          class="button is-success"
                          @click="update"
                          :disabled="!valid"
                      >
                        <template v-if="cartLine">
                          <span class="icon icon--cart"><i class="fas fa-shopping-cart"></i></span>
                          <span>Aktualizovat</span>
                        </template>
                        <template v-else>
                          <span class="icon icon--cart"><i class="fas fa-plus"></i></span>
                          <span>Přidat</span>
                        </template>
                      </button>
                    </span>

                    <button
                        v-if="cartLine && amount === 0"
                        class="button is-white"
                        @click="update"
                    >
                      <span class="icon icon--cart"><i class="fas fa-trash"></i></span>
                      <span>Odebrat</span>
                    </button>

                    <button v-if="offerMeal.price <= 0" class="button" disabled>Nelze objednat</button>
                    <button v-if="soldOut" class="button" disabled>Položka je nedostupná</button>

                  </div>
                </div>

              </div>

      </footer>
    </div>
  </div>
</template>

<script>
import offerMealModalGetters from '../../../store/web/offerMealModal/getter-types';
import offerMealModalActions from '../../../store/web/offerMealModal/action-types';
import cartGetters from "../../../store/web/cart/getter-types";
import cartActions from "../../../store/web/cart/action-types";
import axios from "axios";
export default {
  data() {
    return {
      ingredientGroups: null,
      amount: 1
    }
  },
  methods: {
    close() {
      this.$store.dispatch('offerMealModal/' + offerMealModalActions.HIDE);
    },
    addAmount() {
      this.amount = this.amount + 1;
    },
    removeAmount() {
      let min = 1;
      if (this.cartLine) min = 0;
      if (this.amount > min) {
        this.amount = this.amount - 1;
      }
    },
    updateOfferMeal(amount) {
      this.$store.dispatch('cart/' + cartActions.UPDATE_OFFER_MEAL, {
        offerMeal: this.offerMeal,
        amount: amount,
        ingredients: this.ingredientGroups
      }).then((payload) => {
        this.$store.dispatch('offerMealModal/' + offerMealModalActions.UPDATE, payload);
        this.close();
      });
    },
    update() {
      this.updateOfferMeal(this.amount);
    },
    errorScroll() {
      // console.log('find and scroll to error')
    },
    remove() {
      let amount = 0;
      if (this.cartLine) amount = this.cartLine.amount - 1;
      this.updateOfferMeal(amount);
    },
    toggleIngredient(ingredientGroup, ingredient, value) {
      let ingredientGroups = this.ingredientGroups;
      let ingredients = ingredientGroups[ingredientGroup.id];

      if (!Array.isArray(ingredients)) {
        ingredients = [];
      }
      if (value) {
        ingredients.push(ingredient.id);
      } else {
        ingredients = ingredients.filter(id => id !== ingredient.id);
      }

      if (ingredients.length) {
        ingredientGroups[ingredientGroup.id] = ingredients;
      } else {
        delete ingredientGroups[ingredientGroup.id];
      }

      this.ingredientGroups = null;
      this.ingredientGroups = ingredientGroups;
    },
    checkedIngredient(ingredientGroup, ingredient) {
      if (this.ingredientGroups[ingredientGroup.id]) {
        return !! this.ingredientGroups[ingredientGroup.id].find(id => id === ingredient.id);
      }
      return false;
    },
    hasError(ingredientGroup) {
      return this.errors['ingredient_group_' + ingredientGroup.id];
    },
  },
  computed: {
    valid() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_VALID];
    },
    errors() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_ERRORS];
    },
    visible() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_VISIBLE];
    },
    offerMeal() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_OFFER_MEAL];
    },
    cartLine() {
      if (!this.offerMeal) return null;
      return this.$store.getters['cart/' + cartGetters.GET_OFFER_MEAL_CART_LINE](this.offerMeal);
    },
    soldOut() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_SOLD_OUT];
    },
    configuredPrice() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_PRICE_FORMATTED];
    },
    configuredPackagingPrice() {
      return this.$store.getters['offerMealModal/' + offerMealModalGetters.GET_PACKAGING_PRICE_FORMATTED];
    },
    packagingPrice() {
      if (this.configuredPackagingPrice) return this.configuredPackagingPrice;
      if (this.cartLine) return this.cartLine.packaging_price_formatted;
      return this.offerMeal.packaging_price_formatted;
    },
    price() {
      if (this.configuredPrice) return this.configuredPrice;
      if (this.cartLine) return this.cartLine.price_formatted;
      return this.offerMeal.price_formatted;
    },
    updatedIngredients() {
      if (!this.cartLine) return false;
      return JSON.stringify({ ...this.cartLine.data.ingredients }) !== JSON.stringify(this.ingredientGroups);
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        $('html').addClass('is-clipped');
      } else {
        $('html').removeClass('is-clipped');
        this.ingredientGroups = null;
        this.amount = 1;
      }
    },
    offerMeal(offerMeal) {
      if (offerMeal) {
        this.ingredientGroups = {};
      }
    },
    cartLine(cartLine) {
      if (cartLine) {
        this.amount = cartLine.amount;
        this.ingredientGroups = JSON.parse(JSON.stringify({ ...this.cartLine.data.ingredients }));
      }
    },
    ingredientGroups(value) {
      this.$store.dispatch('offerMealModal/' + offerMealModalActions.CONFIGURE, {
        ingredients: value,
        amount: this.amount,
      });
    },
    amount(value) {
      this.$store.dispatch('offerMealModal/' + offerMealModalActions.CONFIGURE, {
        ingredients: this.ingredientGroups,
        amount: value,
      });
    }
  }
}
</script>

<style>
</style>
